module.exports = __webpack_public_path__ + "img/ttshop_all1.0a0e3bcb.svg";